import { useLanguage } from "../../i18n/LanguageContext";
import { siteConfig } from "../../config/site";
import { BookingButton, InquiryButton } from "../BookingButton";
import { Reveal } from "../Reveal";

export const PriceCTA = () => {
  const { t } = useLanguage();
  return (
    <section className="container-x section !pt-0" data-testid="price-cta-section">
      <Reveal className="grain relative overflow-hidden rounded-[2.5rem] bg-charcoal px-8 py-16 text-cream md:px-16 md:py-24">
        <span aria-hidden className="pointer-events-none absolute -right-10 -top-16 font-display text-[16rem] leading-none text-cream/[0.05] md:text-[22rem]">{siteConfig.price.perBedPerNight}€</span>
        <div className="relative grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-8">
            <p className="eyebrow !text-cream/70">{t.roomsPage.price}</p>
            <h2 className="h2 mt-4 max-w-2xl" data-testid="price-cta-title">{t.priceCta.title}</h2>
            <p className="mt-6 max-w-xl text-base text-cream/70 leading-relaxed md:text-lg">{t.priceCta.text}</p>
            <p className="mt-3 text-xs uppercase tracking-[0.2em] text-cream/50" data-testid="price-cta-note">{t.priceCta.note}</p>
          </div>
          <div className="flex flex-col items-start gap-3 lg:col-span-4 lg:items-end">
            <BookingButton variant="primary" className="!px-7 !py-3.5" testId="price-cta-booking-button" />
            <InquiryButton variant="outline" className="!border-cream/30 !text-cream hover:!bg-cream hover:!text-charcoal !px-7 !py-3.5" testId="price-cta-inquiry-button" />
          </div>
        </div>
      </Reveal>
    </section>
  );
};
